var React = require('react');

function Pencil (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.5338 15.3692L17.4069 2.49609L22.0031 7.09229L9.08735 20.008L4.38218 21.2912L2.79846 19.7075L4.5338 15.3692ZM6.23829 16.4931L5.24206 18.9837L8.0487 18.2182L19.1746 7.09229L17.4069 5.32452L6.23829 16.4931Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.86092 19.8202L4.67894 16.6382L6.09315 15.224L9.27513 18.406L7.86092 19.8202Z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.0533 10.6278L13.8713 7.44584L15.2855 6.03163L18.4675 9.21361L17.0533 10.6278Z","key":2})]);
}

Pencil.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = Pencil;

Pencil.default = Pencil;
